<template>
  <v-row justify="center">
    <v-stepper
      v-model="step"
      style="background: transparent"
      class="auth-container"
    >
      <v-stepper-header>
        <v-row class="ma-0">
          <v-col><slot name="logo"></slot> </v-col>
          <v-col>
            <v-row justify="end"
              ><p class="text-subtitle-active">Step {{ step }} of 4</p></v-row
            >
          </v-col>
        </v-row>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <user-form @registration:complete="completedUserForm()"></user-form>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <verify-email :throttle="verifyEmailTimeout"></verify-email>
        </v-stepper-content>
        <v-stepper-content step="3" class="pa-0">
          <company-form
            :companyData.sync="companyData"
            @update:step="step = $event"
          ></company-form>
        </v-stepper-content>
        <v-stepper-content step="4" class="pa-0">
          <subscription
            @update:step="step = $event"
            :companyData="companyData"
          ></subscription>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-row>
</template>

<script>
import UserForm from './components/UserForm.vue'
import VerifyEmail from './components/VerifyEmail.vue'
import CompanyForm from './components/CompanyForm.vue'
import Subscription from './components/Subscription.vue'
import { auth } from '@/firebaseConfig'
import { mapGetters } from 'vuex'

export default {
  components: {
    UserForm,
    VerifyEmail,
    CompanyForm,
    Subscription,
  },
  data: () => ({
    step: 1,
    verifyEmailTimeout: 0,
    companyData: {},
  }),
  computed: {
    ...mapGetters(['currentUserWorkforceInfo']),
    currentUser() {
      return auth.currentUser
    },
  },
  mounted() {
    if (this.currentUser && this.currentUser.emailVerified === true) {
      this.step = 3
    } else if (this.currentUser) {
      this.step = 2
    }

    if (this.currentUserWorkforceInfo?.firstName) {
      this.companyData.firstName = this.currentUserWorkforceInfo.firstName
    }

    if (this.currentUserWorkforceInfo?.lastName) {
      this.companyData.lastName = this.currentUserWorkforceInfo.lastName
    }
  },
  methods: {
    completedUserForm() {
      this.verifyEmailTimeout = 60
      this.step = 2
    },
  },
}
</script>
